import { motion } from "framer-motion";
import { Search, Scale, ShieldCheck, Blocks } from "lucide-react";

const VALUES = [
  {
    id: "01",
    title: "项目资源收集",
    subtitle: "PROJECT RESOURCE COLLECTION",
    desc: "全网实时监控与优质前端一手情报源调取，严选高回报、可持续、无接盘风险的创新商业机会。",
    icon: Search,
  },
  {
    id: "02",
    title: "专业项目评估",
    subtitle: "PROFESSIONAL PROJECT EVALUATION",
    desc: "12维度风控审查模型，对变现模型、时间成本、资金安全及合规性进行全方位压力测试与实测数据复盘。",
    icon: Scale,
  },
  {
    id: "03",
    title: "专业项目审核",
    subtitle: "PROFESSIONAL PROJECT AUDIT",
    desc: "专家团队闭门审查与盲测落地验证，淘汰99%虚假与高风险劣质项目，确保会员零风险轻资产切入。",
    icon: ShieldCheck,
  },
  {
    id: "04",
    title: "专业项目整合",
    subtitle: "PROFESSIONAL PROJECT INTEGRATION",
    desc: "打造标准化SOP流转体系与团队帮扶，提供落地教程、一对一解疑与社群全量资源无缝匹配与协同。",
    icon: Blocks,
  },
];

export default function CoreValues() {
  return (
    <section id="values" className="relative py-24 lg:py-36 px-5 lg:px-8 bg-[#0A0A0E]" data-testid="core-values-section">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16"
        >
          <p className="font-mono-num text-xs tracking-[0.35em] text-[#D4AF37] mb-4">CORE VALUES · 核心价值</p>
          <h2 className="font-serif-sc text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl leading-snug">
            四重专业体系<br />
            <span className="text-gold-grad">只交付经得起验证的机会</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-px bg-[#D4AF37]/10 border border-[#D4AF37]/10">
          {VALUES.map((v, i) => (
            <motion.article
              key={v.id}
              data-testid={`core-value-${v.id}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              className="group relative bg-[#070709] p-8 lg:p-12 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/0 to-[#D4AF37]/0 group-hover:from-[#D4AF37]/[0.04] group-hover:to-transparent transition-all duration-700" />
              <div className="relative flex items-start justify-between mb-10">
                <span className="font-serif-sc text-6xl lg:text-7xl font-black text-stroke-gold group-hover:text-gold-grad transition-all duration-500">
                  {v.id}
                </span>
                <v.icon className="w-7 h-7 text-[#D4AF37]/50 group-hover:text-[#D4AF37] transition-colors duration-500 mt-2" />
              </div>
              <h3 className="relative font-serif-sc text-2xl lg:text-3xl font-bold tracking-wide mb-2">{v.title}</h3>
              <p className="relative font-mono-num text-[10px] tracking-[0.3em] text-gray-600 mb-6">{v.subtitle}</p>
              <p className="relative text-sm text-gray-400 leading-relaxed">{v.desc}</p>
              <div className="relative mt-8 h-px w-0 group-hover:w-full bg-gradient-to-r from-[#D4AF37] to-transparent transition-all duration-700" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
